import { render, staticRenderFns } from "./EditClzDialog.vue?vue&type=template&id=08fa0214&scoped=true"
import script from "./EditClzDialog.vue?vue&type=script&lang=js"
export * from "./EditClzDialog.vue?vue&type=script&lang=js"
import style0 from "./EditClzDialog.vue?vue&type=style&index=0&id=08fa0214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa0214",
  null
  
)

export default component.exports